import { enumPlanRoles } from "@coreapp/constants";

export type PlanRole = (typeof enumPlanRoles)[keyof typeof enumPlanRoles];

export type PlanUser = {
  name: string;
  role: PlanRole;
  displayName?: string;
  accessTime?: string;
};

export const getPlanOwners = (users: PlanUser[]): PlanUser[] => {
  return users.filter(user => user.role === enumPlanRoles.owner);
};

export const isPlanOwner = (users: PlanUser[], userId: string): boolean => {
  return getPlanOwners(users).some(owner => owner.name === userId);
};

export const getPlanOwnerIds = (users: PlanUser[]): string[] => {
  return getPlanOwners(users).map(owner => owner.name);
};

export const wouldRemoveLastOwner = (
  users: PlanUser[],
  targetUserId: string,
  newRole?: string
): boolean => {
  const owners = getPlanOwners(users);
  if (owners.length <= 1) {
    const isTargetOwner = owners.some(o => o.name === targetUserId);
    if (isTargetOwner && (!newRole || newRole !== enumPlanRoles.owner)) {
      return true;
    }
  }
  return false;
};

export const validateOwnersRemain = (updatedUsers: PlanUser[]): boolean => {
  return getPlanOwners(updatedUsers).length >= 1;
};
